module.exports = {
    'RegisterSetEqualHeights': require('./register-set-equal-heights'),
    'SetEqualHeights': require('./set-equal-heights')
};